/**
 * @format
 */
import { api } from '@/scripts/api';

export const DocumentService = {
    get(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Documents';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${id}`,
            });

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getByGuid(guid) {
        return new Promise((resolve, reject) => {
            const endpoint = `/api/Documents/${guid}/Recipient`;

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getAll(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Documents';

            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            api.post('/api/Documents', payload).then(resolve).catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/${id}`;

            api.patch(service, payload).then(resolve).catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/${id}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },

    deleteAll(ids) {
        return new Promise((resolve, reject) => {
            api.delete('/api/Documents', ids).then(resolve).catch(reject);
        });
    },

    duplicate(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/${id}/Duplicate`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    patchViewedStatus(guid) {
        return new Promise((resolve, reject) => {
            api.post(`/api/Documents/${guid}/ViewDocument`).then(resolve).catch(reject);
        });
    },

    postApprovalRequest(payload) {
        return new Promise((resolve, reject) => {
            api.post('/api/Documents/ApproveDocument', payload).then(resolve).catch(reject);
        });
    },

    postSignature(payload) {
        return new Promise((resolve, reject) => {
            api.post('/api/Documents/Sign', payload).then(resolve).catch(reject);
        });
    },

    postDecline(payload) {
        return new Promise((resolve, reject) => {
            api.post('/api/Documents/Decline', payload).then(resolve).catch(reject);
        });
    },

    voidDocument(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/Documents/reset';
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    postFile(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/Documents/files';
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    generatePdf(guid) {
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/Download/PDF/${guid}`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    generateWord(guid) {
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/Download/DOCX/${guid}`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    getPreview(id){
        return new Promise((resolve, reject) => {
            const service = `/api/Documents/${id}/Preview`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    postPdfFormData(fd) {
        return new Promise((resolve, reject) => {
            const service = '/ms/puppeteer/v1/export/pdf-to-image';

            api.post(service, fd).then(resolve).catch(reject);
        });
    },

    postPdfFromCollateral(payload) {
        return new Promise((resolve, reject) => {
            const service = '/ms/puppeteer/v1/export/file-url-to-image';

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

};
